import React from "react";
import {connect} from "react-redux";
import {StyleSheet, Text, View} from "react-native";
import {compose} from "redux";
import {withTranslation} from "react-i18next";


class HeaderTitreSousTitre extends React.Component{
    constructor(props) {
        super(props);
    }

    render(){
        const styles = StyleSheet.create({
           container:{
               justifyContent:"center",
               alignItems:"center",
               height:"100%"
           } ,
            title:{
                fontSize:16,
                fontWeight:"600",
                fontFamily:this.props.theme.fonts.title,
                color:this.props.theme.colors.tertiary.black1.value,
                marginBottom:-5

            },
            subTitle:{
                fontFamily:this.props.theme.fonts.text,
                fontWeight:"500",
                fontSize:14,
                color:this.props.theme.colors.tertiary.black5.value
            }
        });
        return (
            <View style={styles.container}>
		<View style={{flexDirection: "row"}}>
		  <Text style={styles.title}>{this.props.name}</Text>
		  { this.props.icon }
		</View>

                <Text style={styles.subTitle}>{this.props.nbArticle} {this.props.t('articles')}</Text>
            </View>
        )
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(withTranslation(),connect(mapStateToProps))(HeaderTitreSousTitre);
